import $ from 'jquery/src/jquery';

$(document).on('click', '[data-action="get_popup"]', function (e) {
    ajaxManager.request({
        data: $(this).data(),
        showLoader: true,
        onSuccess: function (response) {
            popupManager.setContent( response.data.content );
        }
    });
});